import { useState } from 'react';

import { PostResendToken } from 'services/registerValidation/postResendToken';
import { GetSearchPersonData } from 'services/registerValidation/getSearchPersonData';
import { PutUpdatePersonalData } from 'services/registerValidation/putUpdatePersonalData';
import { PostValidatePersonalData } from 'services/registerValidation/postValidatePersonalData';

import { ParamsDataAddress, RegistrationValidation, ParamsDataSearchPersonal, ParamsBodySearchPersonal, ParamsBodyValidatePersonalData, ParamsBodyUpdatePersonalData, ParamsDataValidatePersonalData, ParamsDataUpdatePersonalData } from 'utils/typeServices';

const useRegisterValidation = () => {
    const [dataSearchPersonData, setDataSearchPersonData] = useState<RegistrationValidation | false | null>();
    const [dataValidatePersonalData, setDataValidatePersonalData] = useState<ParamsDataValidatePersonalData | false | null>();
    const [dataUpdatePersonalData, setDataUpdatePersonalData] = useState<ParamsDataUpdatePersonalData | false>();
    const [dataResendToken, setDataResendToken] = useState<ParamsDataValidatePersonalData | false>();
    const [dataFormPersonal, setDataFormPersonal] = useState<ParamsDataSearchPersonal>();
    const [dataFormAddress, setDataFormAddress] = useState<ParamsDataAddress>();

    const handleGetSearchPersonData = async (body: ParamsBodySearchPersonal) => {
        const { data, specificError } = await GetSearchPersonData(body);

        if (data) {
            setDataSearchPersonData(data);
        } else {
            setDataSearchPersonData(specificError ? null : false);
        }
    }

    const handleUpdateFormAddress = (body: ParamsDataAddress) => {
        setDataFormAddress(body);
    }

    const handleUpdateFormPersonal = (body: ParamsDataSearchPersonal) => {
        setDataFormPersonal(body);
    }

    const handlePostValidatePersonalData = async (body: ParamsBodyValidatePersonalData) => {
        setDataValidatePersonalData(undefined);
        const { data, specificError } = await PostValidatePersonalData(body);

        if (data) {
            setDataValidatePersonalData(data);
        } else {
            setDataValidatePersonalData(specificError ? null : false);
        }
    }

    const handlePutUpdatePersonalData = async (body: ParamsBodyUpdatePersonalData) => {
        setDataUpdatePersonalData(undefined);
        const { data } = await PutUpdatePersonalData(body);

        if (data) {
            setDataUpdatePersonalData({ ...data, token: `${body.tokenSent}` });
        } else {
            setDataUpdatePersonalData(false);
        }
    }

    const handlePostResendToken = async (body: ParamsBodyValidatePersonalData) => {
        setDataResendToken(undefined);
        const { data } = await PostResendToken(body);

        if (data) {
            setDataResendToken(data);
        } else {
            setDataResendToken(false);
        }
    }

    return { dataSearchPersonData, dataFormPersonal, dataFormAddress, dataUpdatePersonalData, dataValidatePersonalData, dataResendToken, handleGetSearchPersonData, handlePostValidatePersonalData, handlePutUpdatePersonalData, handlePostResendToken, handleUpdateFormAddress, handleUpdateFormPersonal };
}

export default useRegisterValidation;